<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title primary-title>
          {{ $t('revisionesUuid.proposicion') }}
          <v-spacer />
          <v-icon @click="close()">mdi-close</v-icon>
        </v-card-title>
        <v-card-text v-if="dialog">
          <v-form ref="form" lazy-validation v-model="valid" style="height: 100%">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-select
                    v-model="item.proposicion"
                    :label="$t('revisionesUuid.revisionTecnica')"
                    :items="propositionOptions"
                    :rules="requiredRules"
                    required
                    dense
                    outlined
                    hide-details="auto"></v-select>
                </v-col>
                <v-col cols="12">
                  <v-menu
                    v-model="ui.showPicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        dense
                        outlined
                        hide-no-data
                        hide-details="auto"
                        nopev-model="item.fechaProposicion"
                        :value="
                          item.fechaProposicion
                            ? $moment(item.fechaProposicion).format('DD-MM-YYYY')
                            : ''
                        "
                        :label="$t('revisionesUuid.fechaProposicion')"
                        readonly
                        v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                    <v-date-picker
                      first-day-of-week="1"
                      v-model="item.fechaProposicion"
                      @input="ui.showPicker = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <!--REVISOR 1-->
                <div class="hr-sect">{{ `${$t('revisionesUuid.revisor')} 1` }}</div>
                <v-col cols="6">
                  <select-auditores
                    :title="$t('revisionesUuid.revisor')"
                    v-model="item.auditor1"
                    required
                    dense
                    :multiple="false"
                    :clearable="false"
                    auditorOrigen="ORIGEN_PROPOSICION_AUDITOR1"
                    :subalcance="item.subalcance.uuid"
                    outlined
                    :auditoresExcluir="auditoresExcluir"
                    hide-details="auto" />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    :label="$t('enCalidadDe')"
                    required
                    dense
                    outlined
                    hide-details="auto"
                    :rules="requiredRules"
                    v-model="item.enCalidadDeAuditor1" />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    :label="$t('revisionesUuid.observaciones')"
                    v-model="item.observacionesAuditor1"
                    no-resize
                    :required="!isOceGlobal"
                    outlined></v-textarea>
                </v-col>

                <!--REVISOR 2-->
                <div class="hr-sect">{{ `${$t('revisionesUuid.revisor')} 2` }}</div>
                <v-col cols="6">
                  <select-auditores
                    :title="$t('revisionesUuid.revisor')"
                    v-model="item.auditor2"
                    dense
                    :clearable="false"
                    :multiple="false"
                    auditorOrigen="ORIGEN_PROPOSICION_AUDITOR2"
                    :subalcance="item.subalcance.uuid"
                    :auditoresExcluir="auditoresExcluir"
                    outlined
                    hide-details="auto" />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    dense
                    outlined
                    :label="$t('enCalidadDe')"
                    v-model="item.enCalidadDeAuditor2"
                    hide-details="auto" />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    :label="$t('revisionesUuid.observaciones')"
                    v-model="item.observacionesAuditor2"
                    auto-grow
                    outlined></v-textarea>
                </v-col>

                <v-col cols="12" v-if="showCustomFieldsRevision">
                  <div class="hr-sect">{{ $t('custom_fields') }}</div>
                </v-col>
                <v-col
                  v-for="(field, index) in customFieldsRevision"
                  :key="`revision_cf_${index}_${field.nombre}`"
                  cols="12"
                  :md="field.cols || 6">
                  <v-text-field
                    v-if="field.tipo === 'text'"
                    v-model="item.customFields[field.nombre]"
                    :label="field.nombre"
                    dense
                    outlined
                    hide-details="auto"></v-text-field>

                  <v-text-field
                    v-else-if="field.tipo === 'numero'"
                    v-model.number="item.customFields[field.nombre]"
                    :label="field.nombre"
                    dense
                    type="number"
                    step="0.01"
                    outlined
                    hide-details="auto"></v-text-field>

                  <v-checkbox
                    v-else-if="field.tipo === 'bool'"
                    v-model="item.customFields[field.nombre]"
                    :label="field.nombre"
                    color="primary"
                    hide-details></v-checkbox>

                  <v-text-field
                    v-else-if="field.tipo === 'fecha'"
                    v-model="item.customFields[field.nombre]"
                    :label="field.nombre"
                    dense
                    type="date"
                    outlined
                    hide-details="auto"></v-text-field>

                  <v-select
                    v-else-if="field.tipo === 'estatico'"
                    v-model="item.customFields[field.nombre]"
                    :label="field.nombre"
                    :items="estaticosOptions[field.nombre] || []"
                    :multiple="estaticoMultiple[field.nombre] || false"
                    item-text="text"
                    item-value="value"
                    dense
                    outlined
                    hide-details="auto"></v-select>

                  <span v-else-if="field.tipo === 'titulo'" class="text-h6 font-weight-bold">
                    {{ field.nombre }}
                  </span>

                  <span v-else-if="field.tipo === 'subtitulo'" class="text-subtitle-1">
                    {{ field.nombre }}
                  </span>

                  <v-text-field
                    v-else
                    v-model="item.customFields[field.nombre]"
                    :label="field.nombre"
                    dense
                    outlined
                    hide-details="auto"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-checkbox
                    color="primary"
                    v-model="item.set_revisada"
                    :label="$t('revisionesUuid.marcarComoRevisada')"></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-2 mb-2" text color="red lighten-2" @click="close()">
            {{ $t('revisionesUuid.cerrar') }}
          </v-btn>
          <v-btn
            class="mr-2 mb-2"
            :color="item.set_revisada ? 'green lighten-2' : 'orange lighten-2'"
            @click="confirm()">
            <template v-if="item.set_revisada">
              {{ $t('revisionesUuid.guardarYMarcarComoRevisada') }}
            </template>
            <template v-else>
              {{ $t('revisionesUuid.guardarSinFinalizarRevision') }}
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/**
 * @project: certiapp-nuxt
 * @file:    \components\revisiones\ProponerDialog.vue
 * @desc:    ...
 * -------------------------------------------
 * Created Date: 29th October 2021
 * Last Modified: Mon Oct 24 2022
 **/

import SelectAuditores from '~/components/forms/SelectAuditoresMultiple'
import Estados from '~/models/estados'

export default {
  props: {
    value: Boolean,
    proposicion: Object,
    auditoresExcluir: { type: Array, default: () => [] },
  },

  components: {
    SelectAuditores,
  },

  data: () => ({
    dialog: false,
    valid: false,
    item: {},
    estaticosOptions: {},
    estaticoMultiple: {},
    ui: {
      showPicker: false,
    },
  }),

  watch: {
    value(val) {
      this.dialog = val
      if (val) this.open()
    },
  },

  computed: {
    propositionOptions() {
      return [
        {
          text: this.$t('datatable.suitableCaps'),
          value: Estados.DICTAMEN_DECISION_PROPOSICION.APTO,
        },
        {
          text: this.$t('datatable.notSuitableCaps'),
          value: Estados.DICTAMEN_DECISION_PROPOSICION.NO_APTO,
        },
      ]
    },
    requiredRules() {
      return [(v) => !!v || this.$t('revisionesUuid.obligatorio')]
    },
    permiteCustomFieldsRevision() {
      const opciones = this.$auth?.user?.empresa?.configuracion?.opcionesAvanzadasParaEmpresa || {}
      return opciones.permiteUsarCustomFieldsRevision === true
    },
    customFieldsRevision() {
      const fields = this.$auth?.user?.empresa?.configuracion?.customFields?.revision || []
      if (!this.permiteCustomFieldsRevision) return []
      return Array.isArray(fields) ? [...fields] : []
    },
    showCustomFieldsRevision() {
      return this.customFieldsRevision.length > 0
    },

    isCcl() {
      return this.$auth.user.empresa.nombre == 'Ccl'
    },

    isOceGlobal() {
      return this.$auth.user.empresa.codigo == 'oceglobal'
    },
  },

  methods: {
    async open() {
      this.item = { ...this.proposicion }
      this.item.fechaProposicion = new Date().toISOString().substr(0, 10)
      if (!this.item.customFields || typeof this.item.customFields !== 'object') {
        this.$set(this.item, 'customFields', {})
      } else {
        this.$set(this.item, 'customFields', { ...this.item.customFields })
      }

      if (this.item.auditor1 && this.item.auditor1.length > 0) {
        this.item.auditor1 = this.item.auditor1[0]
      }
      this.assignToRevisor()

      this.item.enCalidadDeAuditor1 = this.item.enCalidadDeAuditor1 || 'Revisor'
      this.item.observacionesAuditor1 = this.item.observacionesAuditor1

      if (this.item.auditor2 && this.item.auditor2.length > 0) {
        this.item.auditor2 = this.item.auditor2[0]
      }
      this.item.enCalidadDeAuditor2 = this.item.enCalidadDeAuditor2
      this.item.observacionesAuditor2 = this.item.observacionesAuditor2
      await this.hydrateCustomFieldsRevision()
    },

    getDefaultCustomFieldValue(field) {
      const usarValorInicial = field?.usarValorInicial === true
      const valorInicial = field?.valorInicial

      if (usarValorInicial) {
        switch (field.tipo) {
          case 'bool':
            if (valorInicial === true || valorInicial === false) return valorInicial
            if (valorInicial === 'true') return true
            if (valorInicial === 'false') return false
            return false
          case 'numero':
            if (valorInicial === '' || valorInicial === null || valorInicial === undefined) return null
            return Number.isFinite(Number(valorInicial)) ? Number(valorInicial) : null
          case 'fecha':
            return valorInicial || null
          case 'estatico':
            return valorInicial ?? null
          default:
            return valorInicial ?? ''
        }
      }

      switch (field.tipo) {
        case 'bool':
          return false
        case 'numero':
          return null
        case 'fecha':
          return null
        case 'estatico':
          return null
        case 'titulo':
        case 'subtitulo':
          return null
        default:
          return ''
      }
    },
    normalizeCustomFieldValueByType(field, value) {
      switch (field.tipo) {
        case 'bool':
          if (value === true || value === false) return value
          if (value === 'true') return true
          if (value === 'false') return false
          return false
        case 'numero':
          if (value === '' || value === null || value === undefined) return null
          return Number.isFinite(Number(value)) ? Number(value) : null
        case 'fecha':
          if (!value) return null
          if (typeof value === 'string') return value.substring(0, 10)
          return null
        case 'titulo':
        case 'subtitulo':
          return null
        default:
          return value ?? ''
      }
    },

    async loadEstaticoOptions(field) {
      if (!field.estatico) return
      const estatico = await this.$store.dispatch('estaticos/get', field.estatico)
      const options = estatico.valor.map((v) => ({
        text: v.texto,
        value: v.valor,
      }))
      this.$set(this.estaticosOptions, field.nombre, options)
      this.$set(this.estaticoMultiple, field.nombre, estatico.multiple)
    },

    async hydrateCustomFieldsRevision() {
      if (!this.showCustomFieldsRevision) return

      for (const field of this.customFieldsRevision) {
        if (!(field.nombre in this.item.customFields)) {
          this.$set(this.item.customFields, field.nombre, this.getDefaultCustomFieldValue(field))
        }

        if (field.tipo !== 'estatico') {
          this.$set(
            this.item.customFields,
            field.nombre,
            this.normalizeCustomFieldValueByType(field, this.item.customFields[field.nombre])
          )
          continue
        }

        await this.loadEstaticoOptions(field)
        const options = this.estaticosOptions[field.nombre] || []
        const isMultiple = this.estaticoMultiple[field.nombre] === true
        let saved = this.item.customFields[field.nombre]
        if (saved && typeof saved === 'object' && !Array.isArray(saved)) {
          saved = saved.value ?? saved.valor ?? null
        }

        if (saved == null || saved === '') {
          this.$set(this.item.customFields, field.nombre, isMultiple ? [] : null)
          continue
        }

        if (isMultiple) {
          const savedArray = Array.isArray(saved)
            ? saved
            : typeof saved === 'string' && saved.includes(',')
              ? saved.split(',').map((s) => s.trim()).filter(Boolean)
              : [saved]
          const matches = savedArray
            .map((val) => {
              if (val && typeof val === 'object') return val.value ?? val.valor ?? null
              return val
            })
            .map((val) => options.find((o) => o.value === val))
            .filter(Boolean)
            .map((o) => o.value)
          this.$set(this.item.customFields, field.nombre, matches)
          continue
        }

        const match = options.find((o) => o.value === saved)
        this.$set(this.item.customFields, field.nombre, match ? match.value : null)
      }
    },

    //+-------------------------------------------------
    // assignToRevisor()
    // Checks if there is no item.auditor_º and assigns the revisor
    // -----
    // Created on Mon Oct 17 2022
    //+-------------------------------------------------
    assignToRevisor() {
      if (!this.item.auditor_1 && this.item.revisor) {
        this.item.auditor_1 = this.item.revisor
        // this.item.en_calidad_de_auditor_1 = 'Revisor'
      }
    },

    close() {
      this.dialog = false
      this.item = {}
      this.estaticosOptions = {}
      this.estaticoMultiple = {}
      this.$emit('input', null)
      this.$emit('close')
    },

    async confirm() {
      if (this.$refs.form.validate()) {
        this.$emit('confirm', this.item)
        this.close()
      }
    },
  },
}
</script>
<style scoped>
.hr-sect {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  color: rgba(0, 0, 0, 0.35);
  font-weight: bold;
  margin: 8px 0px;
}
.hr-sect:before,
.hr-sect:after {
  content: '';
  flex-grow: 1;
  background: rgba(0, 0, 0, 0.35);
  height: 1px;
  font-size: 0px;
  line-height: 0px;
  margin: 0px 8px;
}
</style>
